import { Navigate, RouteObject } from 'react-router-dom';
import { ForgeLayout } from './components/layout/ForgeLayout';
import { FORGE_SYSTEM_HEALTH_PATH } from './paths';
import { loadRouteChunk } from './utils/lazyRouteModule';

// Page routes load lazily (route.lazy) so each Forge tab is its own chunk and
// the main bundle stays free of Forge page code. The router awaits the chunk
// during navigation, so no Suspense fallback is needed.
export const forgeRoutes: RouteObject = {
  path: '/forge',
  element: <ForgeLayout />,
  children: [
    { index: true, element: <Navigate to={FORGE_SYSTEM_HEALTH_PATH} replace /> },
    // Dashboards
    {
      path: 'dashboards/system-health',
      lazy: async () => ({
        Component: (await loadRouteChunk(() => import('./pages/dashboard/SystemHealthDashboard')))
          .SystemHealthDashboard,
      }),
    },
    {
      path: 'dashboards/reported-issues',
      lazy: async () => ({
        Component: (await loadRouteChunk(() => import('./pages/dashboard/ReportedIssuesDashboard')))
          .ReportedIssuesDashboard,
      }),
    },
    {
      path: 'dashboards/pr-inference-okrs',
      lazy: async () => ({
        Component: (
          await loadRouteChunk(
            () => import('./pages/dashboard/ProductRecognitionInferenceDashboard')
          )
        ).ProductRecognitionInferenceDashboard,
      }),
    },
    {
      path: 'dashboards/designs',
      lazy: async () => ({
        Component: (await loadRouteChunk(() => import('./pages/dashboard/DesignsDashboard')))
          .DesignsDashboard,
      }),
    },
    {
      path: 'dashboards/design-groups',
      lazy: async () => ({
        Component: (await loadRouteChunk(() => import('./pages/dashboard/DesignGroupsDashboard')))
          .DesignGroupsDashboard,
      }),
    },
    {
      path: 'dashboards/locked-designs',
      lazy: async () => ({
        Component: (await loadRouteChunk(() => import('./pages/dashboard/LockedDesignsDashboard')))
          .LockedDesignsDashboard,
      }),
    },
    {
      path: 'dashboards/vizsim-datasets',
      lazy: async () => ({
        Component: (await loadRouteChunk(() => import('./pages/dashboard/VizSimDatasetsDashboard')))
          .VizSimDatasetsDashboard,
      }),
    },
    // Task lists
    {
      path: 'task-lists/store-dc',
      lazy: async () => ({
        Component: (await loadRouteChunk(() => import('./pages/dashboard/DataCollectionDashboard')))
          .DataCollectionDashboard,
      }),
    },
    {
      path: 'task-lists/review-issues',
      lazy: async () => ({
        Component: (await loadRouteChunk(() => import('./pages/dashboard/ReviewIssuesDashboard')))
          .ReviewIssuesDashboard,
      }),
    },
    {
      path: 'task-lists/unresolved',
      lazy: async () => ({
        Component: (
          await loadRouteChunk(() => import('./pages/dashboard/MasterLabelUnresolvedDashboard'))
        ).MasterLabelUnresolvedDashboard,
      }),
    },
    {
      path: 'task-lists/cleaning',
      lazy: async () => ({
        Component: (await loadRouteChunk(() => import('./pages/dashboard/CleaningTasksDashboard')))
          .CleaningTasksDashboard,
      }),
    },
    // Configuration
    {
      path: 'configuration/remote-dc',
      lazy: async () => ({
        Component: (
          await loadRouteChunk(
            () => import('./pages/configuration/RemoteDataCollectionConfiguration')
          )
        ).RemoteDataCollectionConfiguration,
      }),
    },
    {
      path: 'configuration/recognition-thresholds',
      lazy: async () => ({
        Component: (
          await loadRouteChunk(
            () => import('./pages/configuration/RecognitionThresholdConfiguration')
          )
        ).RecognitionThresholdConfiguration,
      }),
    },
    // labeler-accessible tool routes are registered at top level in App.tsx.
  ],
};
